<template>
    <div class="companyNews xi">
        <nh-com></nh-com>
        <div class="banner">
            <div class="banner-wrap clearfix">
                <div class="banner-text">
                    <h3>公司动态</h3>
                    <p>当前位置：<router-link to="/index">首页</router-link><i class="el-icon-arrow-right"></i><a>公司动态</a></p>
                </div>
            </div>
        </div>
        <div class="companyNews-wrap clearfix">
            <div class="companyNews-left left">
                <ul class="companyNews-list">
                    <li class="companyNews-item">
                        <h3>热烈祝贺我公司荣获2020年度最具影响力企业奖</h3>
                        <div class="companyNews-img">
                            <img src="../../assets/img/no-data.png" alt="">
                        </div>
                        <div class="companyNews-user-date"><i class="el-icon-user-solid"></i><span>发布者：XXXXX</span><i class="el-icon-s-promotion"></i><span>时间：2021-05-11</span></div>
                        <p>9月11日， 2020工业互联网创新峰会于线上盛大开幕，本届大会以“破而后立，智造新生”为主题，政商学界精英齐聚共话工业互联网热点， 围绕工业互联网技术创新、制造业数字化转型、工业互联网产业平台搭建等议题，探索工业互联网产业链新模式，构建工业互联网新生态的同时， 大会也为2019-2020年度中最能代表互联网行业发展的优秀企业献上荣誉。我公司 凭借在行业的持续创新和稳健表现， 荣获“ 2019-2020年度互联网产业最具影响力企业”奖项。</p>
                        <el-button type="primary">详情</el-button>
                    </li>
                    <li class="companyNews-item">
                        <h3>热烈祝贺我公司荣获2020年度最具影响力企业奖</h3>
                        <div class="companyNews-img">
                            <img src="../../assets/img/no-data.png" alt="">
                        </div>
                        <div class="companyNews-user-date"><i class="el-icon-user-solid"></i><span>发布者：XXXXX</span><i class="el-icon-s-promotion"></i><span>时间：2021-05-11</span></div>
                        <p>9月11日， 2020工业互联网创新峰会于线上盛大开幕，本届大会以“破而后立，智造新生”为主题，政商学界精英齐聚共话工业互联网热点， 围绕工业互联网技术创新、制造业数字化转型、工业互联网产业平台搭建等议题，探索工业互联网产业链新模式，构建工业互联网新生态的同时， 大会也为2019-2020年度中最能代表互联网行业发展的优秀企业献上荣誉。我公司 凭借在行业的持续创新和稳健表现， 荣获“ 2019-2020年度互联网产业最具影响力企业”奖项。</p>
                        <el-button type="primary">详情</el-button>
                    </li>
                    <li class="companyNews-item">
                        <h3>热烈祝贺我公司荣获2020年度最具影响力企业奖</h3>
                        <div class="companyNews-img">
                            <img src="../../assets/img/no-data.png" alt="">
                        </div>
                        <div class="companyNews-user-date"><i class="el-icon-user-solid"></i><span>发布者：XXXXX</span><i class="el-icon-s-promotion"></i><span>时间：2021-05-11</span></div>
                        <p>9月11日， 2020工业互联网创新峰会于线上盛大开幕，本届大会以“破而后立，智造新生”为主题，政商学界精英齐聚共话工业互联网热点， 围绕工业互联网技术创新、制造业数字化转型、工业互联网产业平台搭建等议题，探索工业互联网产业链新模式，构建工业互联网新生态的同时， 大会也为2019-2020年度中最能代表互联网行业发展的优秀企业献上荣誉。我公司 凭借在行业的持续创新和稳健表现， 荣获“ 2019-2020年度互联网产业最具影响力企业”奖项。</p>
                        <el-button type="primary">详情</el-button>
                    </li>
                </ul>
                <button class="more-btn">更多动态</button>
            </div>
            <div class="companyNews-right right">
                <div class="hot-news">
                    <div class="hot-newstit">
                        <h3>热门新闻</h3>
                    </div>
                    <div class="hot-news-list">
                        <div class="hot-news-list">
                            <div class="hot-news-img-first">
                                <img src="../../assets/img/news_img.jpg" width="100%" alt="">
                            </div>
                            <div class="hot-news-info-first">
                                <p>古巴与印度：全民免费医疗的宿命</p>
                                <span>2021-05-12</span>
                            </div>
                        </div>
                        <div class="hot-news-list clearfix">
                            <div class="hot-news-img left">
                                <img src="../../assets/img/news_img.jpg" alt="">
                            </div>
                            <div class="hot-news-info left">
                                <p>古巴与印度：全民免费医疗的宿命</p>
                                <span>2021-05-12</span>
                            </div>
                        </div>
                        <div class="hot-news-list clearfix">
                            <div class="hot-news-img left">
                                <img src="../../assets/img/news_img.jpg" alt="">
                            </div>
                            <div class="hot-news-info left">
                                <p>古巴与印度：全民免费医疗的宿命</p>
                                <span>2021-05-12</span>
                            </div>
                        </div>
                        <div class="hot-news-list clearfix">
                            <div class="hot-news-img left">
                                <img src="../../assets/img/news_img.jpg" alt="">
                            </div>
                            <div class="hot-news-info left">
                                <p>古巴与印度：全民免费医疗的宿命</p>
                                <span>2021-05-12</span>
                            </div>
                        </div>
                        <div class="hot-news-list clearfix">
                            <div class="hot-news-img left">
                                <img src="../../assets/img/news_img.jpg" alt="">
                            </div>
                            <div class="hot-news-info left">
                                <p>古巴与印度：全民免费医疗的宿命</p>
                                <span>2021-05-12</span>
                            </div>
                        </div>
                        <div class="hot-news-list clearfix">
                            <div class="hot-news-img left">
                                <img src="../../assets/img/news_img.jpg" alt="">
                            </div>
                            <div class="hot-news-info left">
                                <p>古巴与印度：全民免费医疗的宿命</p>
                                <span>2021-05-12</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="hot-news">
                    <div class="hot-newstit">
                        <h3>联系我们</h3>
                    </div>
                    <div class="contact-us-img">
                        <img src="../../assets/img/contact-us-img.jpg" width="100%" alt="">
                    </div>
                    <div class="contact-us-info">
                        <p><i class="el-icon-s-promotion"></i>河南省-郑州市-二七区 大学路与政通路交叉口升龙天玺6楼622室</p>
                        <!--<p><i class="el-icon-phone"></i>18639512888</p>-->
                    </div>
                </div>
            </div>
        </div>
        <ft-com></ft-com>
        <rt-bar></rt-bar>
    </div>
</template>

<script>
    import ftCom from '../../components/footer';
    import nhCom from "../../components/navheader";
    // import rtBar from "../../components/right";
    export default {
        name: "companyNews",
        components: {
            ftCom,
            nhCom,
            // rtBar
        },
    }
</script>

<style scoped>
    .companyNews{
        background: #f7f7f7;
    }
    .banner {
        width: 100%;
        height: 160px;
        background: url("../../assets/img/news_banner.jpg")center no-repeat;
    }

    .banner-wrap {
        position: relative;
        width: 1200px;
        height: 100%;
        margin: 0 auto;
    }

    .banner-text {
        float: left;
    }

    .banner-text h3 {
        padding-top: 35px;
        font-size: 26px;
        font-weight: normal;
        color: #ffffff;
    }

    .banner-text p {
        font-size: 14px;
        color: #ffffff;
        margin-top: 20px;
    }

    .banner-text p a {
        color: #ffffff;
        font-size: 14px;
        margin: 0 5px;
    }
    /*---------*/
    .companyNews-wrap{
        width: 1200px;
        margin: 35px auto;
    }
    .companyNews-wrap .companyNews-left{
        width: 880px;
    }
    .companyNews-wrap .companyNews-right{
        width: 300px;
    }
    .companyNews-left .more-btn{
        width: 100%;
        background: #FFFFFF;
        height: 50px;
        line-height: 50px;
        text-align: center;
        font-size: 16px;
        color: #666666;
    }
    .companyNews-left .more-btn:hover{
        cursor: pointer;
        background: #1fb7a6;
        color: #FFFFFF;
    }
    .companyNews-list .companyNews-item{
        background: #FFFFFF;
        padding: 25px;
        margin-bottom: 20px;
    }
    .companyNews-list .companyNews-item h3{
        font-size: 26px;
        color: #333333;
        font-weight: bold;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .companyNews-list .companyNews-item .companyNews-img{
        margin: 20px 0;
        width: 100%;
        max-height: 300px;
        overflow: hidden;
        border: 1px solid #f4f4f4;
    }
    .companyNews-list .companyNews-item .companyNews-img img{
        width: 100%;
    }
    .companyNews-user-date i{
        color: #1fb7a6;
        font-size: 16px;
        margin-right: 5px;
    }
    .companyNews-user-date span{
        color: #666666;
        font-size: 16px;
        margin-right: 30px;
    }
    .companyNews-item p{
        margin: 10px 0;
        font-size: 14px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 4;
        overflow: hidden;
    }
    /*----------*/
    .hot-news{
        padding: 15px;
        box-sizing: border-box;
        background: #FFFFFF;
        margin-bottom: 20px;
    }
    .hot-news .hot-newstit{
        border-bottom: 1px solid #e5e5e5;
    }
    .hot-news h3{
        display: inline-block;
        border-bottom: 2px solid #1fb7a6;
        font-size: 18px;
        color: #333333;
    }
    .hot-news-list{
        margin: 15px 0;
    }
    .hot-news-img-first{
        width: 100%;
        height: 150px;
        background: #e5e5e5;
        line-height: 150px;
        overflow: hidden;
    }
    .hot-news-list .hot-news-img{
        width: 102px;
        height: 60px;
        background: #e5e5e5;
        line-height: 60px;
        overflow: hidden;
    }
    .hot-news-list .hot-news-img img,.hot-news-list .hot-news-img-first img{
        width: 100%;
    }
    .hot-news-list .hot-news-info{
        width: calc(100% - 112px);
        margin-left: 10px;
    }
    .hot-news-list .hot-news-info-first p{
        color: #333333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .hot-news-list .hot-news-info p{
        color: #333333;
        line-height: 1.3;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
    }
    .hot-news-list .hot-news-info span,.hot-news-list .hot-news-info-first span{
        color: #999999;
        font-size: 12px;
    }
    .contact-us-img{
        margin-top: 15px;
        width: 100%;
        height: 200px;
        overflow: hidden;
    }
    .contact-us-info i{
        font-size: 16px;
        margin-right: 10px;
    }
</style>

